module.exports = __webpack_public_path__ + "img/6.81f2fd27.jpg";